// Online Hizmetler adresini normalize eder: bos/"#" ise varsayilan adres,
// sema yoksa (ornek "online.tbhport.com") basina https:// eklenir.
export function onlineServicesHref(url?: string) {
  const value = url && url.trim() !== '' && url.trim() !== '#' ? url.trim() : 'https://online.tbhport.com';
  return /^(https?:)?\/\//i.test(value) ? value : `https://${value}`;
}
